require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-carl-cox-pure.json") })
        }
      }, "path---interview-carl-cox-pure");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-carl-cox-pure!./.cache/json/interview-carl-cox-pure.json
// module id = 660
// module chunks = 231608221292675